import { gql, useQuery } from "@apollo/client";
import { Select } from "../base/Form";
import useRetryOn429 from "hooks/useRetryOn429";

const FETCH_ODOO_INCOTERMS = gql`
  query FETCH_ODOO_INCOTERMS($company: String!) {
    odooIncoterms(company: $company)
  }
`;

const OdooIncotermsSelector = ({ company, value, onSelect, ...rest }) => {
  const { loading, error, data, refetch } = useQuery(FETCH_ODOO_INCOTERMS, {
    variables: { company },
  });
  const { isAutoRetrying } = useRetryOn429({ error, refetch });

  const odooIncoterms = data ? JSON.parse(data.odooIncoterms) : [];

  return (
    <Select
      value={value || "0"}
      onChange={(e) => onSelect(e.target.value)}
      {...rest}
    >
      {loading || isAutoRetrying ? (
        <option value="0" disabled>
          loading...
        </option>
      ) : error ? (
        <option value="0" disabled>
          {error.message}
        </option>
      ) : (
        <>
          <option value="0" disabled>
            --- Select ---
          </option>
          {odooIncoterms.map((i, index) => (
            <option key={index} value={i.id}>
              {i.name}
            </option>
          ))}
        </>
      )}
    </Select>
  );
};

export default OdooIncotermsSelector;
